import * as ROUTES from '../config/routes';

import PeopleOutlineTwoToneIcon from '@mui/icons-material/PeopleOutlineTwoTone';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import ApartmentTwoToneIcon from '@mui/icons-material/ApartmentTwoTone';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import MobileFriendlySharpIcon from '@mui/icons-material/MobileFriendlySharp';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import FilePresentIcon from '@mui/icons-material/FilePresent';


const button = {
    size: 'large',
    iconStyle: {
        color: 'rgba(255, 255, 255, 0.3)',
        fontSize: '1.25rem',
        marginRight: '0.5rem',
        flexShrink: 0,
    },
    style: {
        display: 'flex',
        color: 'rgba(255, 255, 255, 0.7)',
        width: '100%',
        justifyContent: 'flex-start',
        paddingBottom: '0.3rem',
    },
    sx: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        position: 'relative',
        boxSizing: 'border-box',
        tapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        outline: '0px',
        border: '0px',
        margin: '0px',
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        appearance: 'none',
        textDecoration: 'none',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
        fontSize: '0.875rem',
        lineHeight: '1.75',
        minWidth: 'auto',
        borderRadius: '10px',
        transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        color: 'rgb(255, 255, 255)',
        fontWeight: 'bold',
        textTransform: 'none',
        padding: '0.5rem 1rem',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.06)',
            color: '#ff5d00 !important',
            '& svg': {
                color: '#ff5d00 !important'
            }
        }
    },
    variant: 'text'
}

const childButton = {
    ...button,
    sx: {
        ...button.sx,
        //paddingLeft: '1rem',
        
        paddingLeft: '1.5rem'
    }
}

const HasPermission = (permissions, area, action) => {
    return permissions && permissions[area] && permissions[area][action];
}

const navItems = (permissions) => [
    {
        icon: (<HomeTwoToneIcon style={button.iconStyle} />),
        order: 0,
        visible: true,
        route: ROUTES.ADMIN_DASHBOARD,
        title: 'Home',
        ...button
    },
    {
        icon: (<ApartmentTwoToneIcon style={button.iconStyle} />),
        order: 1,
        visible: HasPermission(permissions, 'Clients', 'read'),
        route: ROUTES.ADMIN_CLIENTS,
        title: 'Clients',
        ...button
    },
    {
        icon: (<PeopleOutlineTwoToneIcon style={button.iconStyle} />),
        order: 2,
        visible: HasPermission(permissions, 'Users', 'read'),
        route: ROUTES.ADMIN_USERS,
        title: 'Users',
        ...button
    },
    {
        icon: (<PeopleOutlineTwoToneIcon style={button.iconStyle} />),
        order: 3,
        visible: HasPermission(permissions, 'Roles', 'read'),
        route: ROUTES.ADMIN_ROLES,
        title: 'Roles',
        ...button
    },
    {
        icon: (<PeopleOutlineTwoToneIcon style={button.iconStyle} />),
        order: 4,
        visible: HasPermission(permissions, 'Permissions', 'read'),
        route: ROUTES.ADMIN_PERMISSION,
        title: 'Permissions',
        ...button
    },
    {
        icon: (<LibraryBooksIcon style={button.iconStyle} />),
        order: 5,
        visible: true,
        route: ROUTES.RESOURCES,
        title: 'Resources',
        ...button
    },
    {
        icon: (<TravelExploreIcon style={button.iconStyle} />),
        order: 6,
        visible: true,
        title: 'CbCR',
        children: [
            {
                icon: 'DataSources',
                order: 1,
                visible: HasPermission(permissions, 'Data Sources', 'read'),
                route: ROUTES.DATA_SOURCE,
                title: 'Data Sources',
                ...childButton
            },
            {
                icon: 'AnalyticConsole',
                order: 2,
                visible: true,
                route: ROUTES.ANALYTIC_CONSOLES,
                title: 'Analytics Console',
                ...childButton
            },
        ],
        ...button
    },
    {
        icon: (<MobileFriendlySharpIcon style={button.iconStyle} />),
        order: 7,
        visible: true,
        title: 'Pillar Two',
        children: [
            {
                icon: 'DataSources',
                order: 1,
                visible: HasPermission(permissions, 'Data Sources', 'read'),
                route: ROUTES.PILLAR_TWO_DATA_SOURCES,
                title: 'Data Sources',
                ...childButton
            },
            {
                icon: 'AnalyticConsole',
                order: 2,
                visible: true,
                route: ROUTES.PILLAR_TWO_ANALYTICS_CONSOLE,
                title: 'Analytics Console',
                ...childButton
            },
        ],
        ...button
    }
];

export default navItems;